module.exports = __webpack_public_path__ + "img/hyf-loader-logo.9e5875d1.png";